export default __webpack_public_path__ + "static/media/bubble_nova_l2.ac083b62.png";